import React from "react";
import {useHistory} from "react-router-dom";
import Button from "../../lib/appfuse-react/component/Button";

function RouteButton(props) {
    const {text, path, route} = props;
    const history = useHistory();

    return <Button text={text} variant="text" color={path===route? '#C98BDB':'inherit'} onClick={() => history.push(route)} />;
}

export default RouteButton;